import type { MarketGroupsApi } from "@/v2/api/metadata/market-groups";
import type { MarketsApi } from "@/v2/api/metadata/markets";
import type { SportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import { createAddDialog } from "./add";
import { createDeleteDialog } from "./delete";
import { createEditDialog } from "./edit";

export function createDialogs(options: {
  ctx: BackofficeContext;
  marketGroupsApi: MarketGroupsApi;
  sportsApi: SportsApi;
  marketsApi: MarketsApi;
}) {
  return {
    add: createAddDialog(options),
    delete: createDeleteDialog(options),
    edit: createEditDialog(options),
  };
}
